export default __webpack_public_path__ + "static/media/polycon.af9dc319.svg";